"use client"

import { useEffect, useState, type ReactNode } from 'react'

/**
 * SafeHydration component ensures that children are only rendered after hydration is complete.
 * This prevents hydration mismatches and errors related to server/client rendering differences.
 */
export function SafeHydration({ children }: { children: ReactNode }) {
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  return (
    <>
      {isHydrated ? (
        children
      ) : (
        <div style={{ visibility: 'hidden' }}>Hydrating...</div>
      )}
    </>
  )
}

/**
 * SafeHydrationProvider is a higher-order component that wraps the entire app
 * to ensure all client components are only rendered after hydration.
 */
export function SafeHydrationProvider({ children }: { children: ReactNode }) {
  return <SafeHydration>{children}</SafeHydration>
} 